import { render, staticRenderFns } from "./AlertTemplateAdmin.vue?vue&type=template&id=ed2be3c8&"
import script from "./AlertTemplateAdmin.vue?vue&type=script&lang=js&"
export * from "./AlertTemplateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AlertTemplateAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports